/**
 * Environment Configuration
 * 
 * This file provides centralized access to all configuration values.
 * It checks window.APP_CONFIG first (for production builds with runtime config),
 * then falls back to process.env (for development).
 * 
 * Usage:
 *   import { Config } from 'config/envConfig';
 *   const host = Config.NODE_SERVER_HOST;
 *   
 *   // Or use getEnv for dynamic access (backward compatible)
 *   import { getEnv } from 'config/envConfig';
 *   const host = getEnv('REACT_APP_NODE_SERVER_HOST');
 */

// Helper to get config value from window.APP_CONFIG or process.env
const getEnvValue = (key, defaultValue = '') => {
  if (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG[key] !== undefined) {
    return window.APP_CONFIG[key];
  }
  const envValue = process.env[key];
  // Return default if env value is undefined, null, or empty string
  if (envValue === undefined || envValue === null || envValue === '') {
    return defaultValue;
  }
  return envValue;
};

// =============================================================================
// CENTRALIZED CONFIG OBJECT
// =============================================================================
export const Config = {
  // ==================== Server Addresses ====================
  HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  PORT: getEnvValue('PORT', '3000'),
  NODE_SERVER_HOST:getEnvValue('REACT_SERVER_HOST', 'localhost'),
  NODE_SERVER_PORT: getEnvValue('NODE_SERVER_PORT', '443/nodejs'),
  FAST_API_HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  FAST_API_PORT: getEnvValue('FAST_API_PORT', '443/fastapi'),
  SOCKET_MANAGER_HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  SOCKET_MANAGER_PORT: getEnvValue('SOCKET_MANAGER_PORT','443'),

  // ==================== Security ====================
  USE_SECURED_CONNECTION: getEnvValue('REACT_APP_USE_SECURED_CONNECTION', 'true'),

  // ==================== Razorpay ====================
  RAZORPAY_API_KEY:getEnvValue('REACT_APP_RAZORPAY_API_KEY', "rzp_live_h03c6zqtleeZjN"),

  // ==================== Product Support ====================
  PRODUCT_SUPPORT_DOMAIN: getEnvValue('PRODUCT_SUPPORT_HOST', ''),

  // ==================== Recrawling ====================
  MINIMUM_RECRAWL_INTERVAL:  '7',

  // ==================== Support ====================
  SUPPORT_URL: getEnvValue('REACT_APP_SUPPORT_URL', ''),

  // ==================== File Constraints ====================
  MAX_TOTAL_ATTACHMENT_COUNT:  '5',
  MAX_ATTACHMENT_PAGE_COUNT: '5',
  TEXT_FILE_MAX_CHARS: '24000',

  // ==================== Google OAuth ====================
  GOOGLE_CLIENT_DRIVE_ID: getEnvValue('REACT_APP_GOOGLE_CLIENT_DRIVE_ID', '898842397297-09dh82j7t2d9ri2el4hnmvh4f93apjkr.apps.googleusercontent.com'),

  // ==================== Build Config ====================
  USE_FRONTEND_BUILD: getEnvValue('REACT_APP_USE_FRONTEND_BUILD', 'false'),
  PUBLIC_URL: getEnvValue('PUBLIC_URL', ''),

  META_APP_ID: getEnvValue('REACT_APP_META_APP_ID', ''),
  WA_CONFIG_ID: getEnvValue('REACT_APP_WA_CONFIG_ID', ''),

  // ==================== Computed URLs ====================
  get IS_HTTPS() {
    return this.USE_SECURED_CONNECTION === 'true';
  },
  get PROTOCOL() {
    return this.IS_HTTPS ? 'https' : 'http';
  },
  get WS_PROTOCOL() {
    return this.IS_HTTPS ? 'wss' : 'ws';
  },
};

// =============================================================================
// BACKWARD COMPATIBLE getEnv FUNCTION
// =============================================================================
export const getEnv = (key) => {
  return getEnvValue(key);
};

export default Config;
